<template>
  <v-card class="newProduct pa-10" flat>
    <v-progress-linear
      v-if="progress"
      fixed
      top
      v-model="progress"
      color="pink"
      style="z-index: 800;"
    ></v-progress-linear>

    <v-card-title class="pa-0">
      <div>{{ $route.name == 'NewProduct' ? '新增商品' : '更新商品' }}</div>
      <v-spacer></v-spacer>
      <div>
        <v-switch label="上架" v-model="product.shelf"></v-switch>
      </div>
    </v-card-title>
    <v-divider class="mb-5"></v-divider>

    <v-row>
      <v-col>
        <v-subheader>主播</v-subheader>
      </v-col>
      <v-col>
        <v-select 
          :items="sellers" 
          item-value="id"
          dense 
          placeholder="選擇主播" 
          v-model="product.seller_id"
          :rules="[$rules.integer]"
          :disabled="updating"
        >
          <template v-slot:item="{ item }">
            <v-avatar size="30" class="mr-2">
              <v-img :src="$HOST_URL + item.usericon"/>
            </v-avatar>
            <span>{{ item.nickname }}</span>
          </template>
          <template v-slot:selection="{ item }">
            <v-avatar size="20" class="mr-1">
              <v-img :src="$HOST_URL + item.usericon"/>
            </v-avatar>
            <span>{{ item.nickname }}</span>
          </template>
        </v-select>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-subheader>商品類型</v-subheader>
      </v-col>
      <v-col>
        <v-select 
          :items="$product_types" 
          dense 
          placeholder="選擇商品類型"
          v-model="product.product_type"
          :rules="[$rules.notEmpty]"
          :disabled="updating"
        ></v-select>
      </v-col>
    </v-row>

    <v-row v-if="product.product_type == 'clothes'">
      <v-col>
        <v-subheader>衣物類型</v-subheader>
      </v-col>
      <v-col>
        <v-select 
          :items="clothes_types" 
          item-text="name"
          item-value="num"
          dense 
          placeholder="選擇衣物類型"
          v-model="product.clothes_type"
          :rules="[$rules.notEmpty]"
        ></v-select>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-subheader>商品標題</v-subheader>
      </v-col>
      <v-col>
        <v-text-field 
          dense 
          v-model="product.title"
          :rules="[$rules.notEmpty]"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-subheader>內容</v-subheader>
      </v-col>
      <v-col>
        <v-textarea dense outlined hide-details v-model="product.remark"></v-textarea>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-subheader>
          <div class="peach"></div>桃子
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="ml-2" v-bind="attrs" v-on="on">fa-question-circle</v-icon>
            </template>
            <div>最小 {{ $product_price_limit[product.product_type] ? $product_price_limit[product.product_type].min : '不限制' }}</div>
            <div>最大 {{ $product_price_limit[product.product_type] ? $product_price_limit[product.product_type].max : '不限制' }}</div>
          </v-tooltip>
        </v-subheader>
      </v-col>
      <v-col>
        <v-text-field 
          dense 
          v-model="product.price"
          :rules="[$rules.price(product.price, product.product_type)]"
          :disabled="updating"
        ></v-text-field>
      </v-col>
      <v-col class="d-flex">
        <v-subheader class="pink--text">
          台幣
        </v-subheader>
        <v-text-field 
          dense 
          :value="product.price > 0 ? $func.peach2price(product.price) : 0"
          disabled
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row v-if="product.product_type == 'clothes'">
      <v-col>
        <v-subheader>使用時間(hour)</v-subheader>
      </v-col>
      <v-col>
        <v-text-field 
          dense 
          v-model="product.use_time"
          :rules="[$rules.integer]"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-subheader>優先度(↑)</v-subheader>
      </v-col>
      <v-col>
        <v-text-field 
          dense 
          v-model.number="product.priority"
          :rules="[$rules.integer]"
          :disabled="true"
        ></v-text-field>
      </v-col>
    </v-row>

   <!--  <v-row v-if="audios.length">
      <v-col>
        <v-subheader>錄音</v-subheader>
      </v-col>
      <v-col class="d-flex flex-wrap">
        <div 
          v-for="(n, i) in 1" 
          class="file-input" 
          @click="$refs[`audio${i}`][0].click()"
        >
          <template v-if="!audios[i]">
            <div class="uploadText">
              <v-icon>fa-plus</v-icon>
              Select File
            </div>
            <input 
              type="file" 
              :ref="`audio${i}`" 
              :accept="$accept_file_type.audio"
              onclick="this.value = null" 
              @change="uploadAudio(i)"
            /> 
          </template>
          <template v-else>
            <v-icon class="delete" @click.stop="deleteAudio(i)">fa-times-circle</v-icon>
            <audio 
              controls 
              :ref="`audioNode${i}`" 
              v-show="audios[i]" 
              :src="product.audios[i]"
            ></audio>
          </template>
        </div>
      </v-col>
    </v-row> -->

    <v-row v-if="['story', 'chat'].includes(product.product_type)">
      <v-col>
        <v-subheader>動態類型</v-subheader>
      </v-col>
      <v-col>
        <v-chip-group active-class="pink--text" mandatory v-model="product.story_type">
          <v-chip outlined class="mr-4" value="video">
            <v-icon class="mr-2">fas fa-video</v-icon>
            影片
          </v-chip>
          <v-chip outlined value="image">
            <v-icon class="mr-2">fas fa-images</v-icon>
            圖片
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>

    <v-row v-if="videos.length && (['story', 'chat'].includes(product.product_type) ? product.story_type == 'video' : true )">
      <v-col>
        <v-subheader>影片</v-subheader>
      </v-col>
      <v-col class="d-flex flex-wrap">
        <div 
          v-for="(video, i) in videos" 
          :key="i"
          class="file-input" 
          @click="$refs[`video${i}`][0].click()"
        >
          <template v-if="video.src">
            <v-icon class="delete" @click.stop="deleteProductUnit(video)">fa-times-circle</v-icon>
            <video-player 
              v-once
              :ref="`videoNode${i}`" 
              class="video-player" 
              :playsinline="true" 
              :options="$func.videoOption({
                src: video.src,
                type: video.type,
                autoplay: true,
                muted: true,
                loop: true,
                controls: false,
              })"></video-player>
          </template>
          <template v-else>
            <div class="uploadText">
              <v-icon>fa-plus</v-icon>
              Select File
            </div>
            <input 
              type="file" 
              :ref="`video${i}`" 
              :accept="$accept_file_type.video"
              onclick="this.value = null" 
              @change="uploadVideo(i)"
            /> 
          </template>
        </div>
      </v-col>
    </v-row>

    <v-row v-if="free_images.length">
      <v-col>
        <v-subheader>公開圖片</v-subheader>
      </v-col>
      <v-col class="d-flex flex-wrap align-center">
        <div 
          v-for="(image, i) in free_images"
          class="file-input" 
          @click="$refs[`free_image${i}`][0] ? $refs[`free_image${i}`][0].click() : ''"
        >
          <template v-if="image.src">
            <v-icon class="delete" @click.stop="deleteProductUnit(image)">fa-times-circle</v-icon>
            <v-img :src="image.src" contain/>
          </template>
          <template v-else>
            <input 
              type="file" 
              :ref="`free_image${i}`" 
              :accept="$accept_file_type.image" 
              onclick="this.value = null" 
              @change="uploadImage(i, 'free_image')"
            />
            <div class="uploadText">
              <v-icon>fa-plus</v-icon>
              Select File
            </div>
          </template>
        </div>
        <div v-if="free_images.length < free_image_max" class="file-add" @click="free_images.push($func.deepCopy(unit))">
          <v-icon>fa-plus</v-icon>
          Add
        </div>
      </v-col>
    </v-row>

    <v-row v-if="images.length && (['story', 'chat'].includes(product.product_type) ? product.story_type == 'image' : true )">
      <v-col>
        <v-subheader>商品圖片</v-subheader>
      </v-col>
      <v-col class="d-flex flex-wrap align-center">
        <div 
          v-for="(image, i) in images"
          class="file-input" 
          @click="$refs[`image${i}`][0] ? $refs[`image${i}`][0].click() : ''"
        >
          <template v-if="image.src">
            <v-icon class="delete" @click.stop="deleteProductUnit(image)">fa-times-circle</v-icon>
            <v-img :src="image.src" contain/>
          </template>
          <template v-else>
            <input 
              type="file" 
              :ref="`image${i}`" 
              :accept="$accept_file_type.image" 
              onclick="this.value = null" 
              @change="uploadImage(i, 'image')"
            />
            <div class="uploadText">
              <v-icon>fa-plus</v-icon>
              Select File
            </div>
          </template>
        </div>
        <div v-if="images.length < image_max" class="file-add" @click="images.push($func.deepCopy(unit))">
          <v-icon>fa-plus</v-icon>
          Add
        </div>
      </v-col>
    </v-row>

    <v-row class="mt-6">
      <v-btn block dark color="indigo" @click="formIsValid ? $root.$emit('confirmDialog', submit, hint, 'fas fa-exchange-alt') : ''">送出</v-btn>
    </v-row>

    <video id="upload" class="hidden"/>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import videojs from 'video.js'
export default {
  data() {
    return {
      unit: {src: '', data: '', type: '', uuid: '', new: true},
      sellers: [],
      videos: [],
      audios: [],
      images: [],
      free_images: [],
      progress: 0,
      product: {
        seller_id: '',
        title: '',
        price: '',
        remark: '',
        use_time: 0,
        priority: 0,
        shelf: true,
        product_type: '',
        clothes_type: '',
        story_type: ''
      },
    }
  },
  created() {
    this.getSellers()
    if(this.updating) {
      this.getProductData()
    }
  },
  computed: {
    ...mapState('global', ['clothes_types']),
    updating() {
      return this.$route.name == 'EditProduct'
    },
    hint() {
      return `桃子為 <span class="d-inline-block pink--text"><div class="peach"></div>${this.product.price}</span>，換算台幣為 ${this.$func.peach2price(this.product.price)}`
    },
    formIsValid() {
      return (
        this.$rules.integer(this.product.seller_id) &&
        this.$rules.notEmpty(this.product.product_type) &&
        (this.product.product_type == 'clothes' ? this.$rules.notEmpty(this.product.clothes_type) : true) &&
        this.$rules.notEmpty(this.product.title) &&
        this.$rules.notEmpty(this.product.remark) &&
        this.$rules.price(this.product.price, this.product.product_type) &&
        (this.product.product_type == 'clothes' ? this.$rules.integer(this.product.use_time) : true) &&
        this.$rules.integer(this.product.priority)
      )
    },
    image_max() {
      if(!this.product.product_type) {
        return 0
      }
      return this.$product_upload_rules[this.product.product_type].image.max.charged
    },
    free_image_max() {
      if(!this.product.product_type) {
        return 0
      }
      return this.$product_upload_rules[this.product.product_type].image.max.uncharged
    }
  },
  watch: {
    'product.product_type'() {
      if(this.updating) {
        return
      }
      this.images = []
      this.free_images = []
      this.videos = []
      this.padProductUnit()
    },
  },
  methods: {
    padProductUnit() {
      let image_max = 0
      image_max = Math.min(this.$product_upload_rules.image_default, this.image_max)
      while(this.images.length < image_max) {
        this.images.push(this.$func.deepCopy(this.unit))
      }
      let free_image_max = image_max = Math.min(this.$product_upload_rules.image_default, this.free_image_max)
      while(this.free_images.length < free_image_max) {
        this.free_images.push(this.$func.deepCopy(this.unit))
      }
      let video_max = this.$product_upload_rules[this.product.product_type].video.max
      while(this.videos.length < video_max) {
        this.videos.push(this.$func.deepCopy(this.unit))
      }
    },
    async uploadVideo(i) {
      let video = event.target.files[0]
      let blob = URL.createObjectURL(video)
      if(!await this.$func.fileValidation(video, this.product.product_type)) {
        return
      }
      this.videos[i].data = video
      this.videos[i].src = blob
      this.videos[i].type = video.type
      this.videos[i].new = true
      this.$forceUpdate()
    },
    // uploadAudio(i) {
    //   let audio = event.target.files[0]
    //   let fileSize = audio.size
    //   if(fileSize > 5242880) {
    //     this.$root.$emit('alert', 'error', '上傳失敗，檔案過大 (5MB)')
    //     return
    //   }
    //   this.audios[i] = audio
    //   let blob = URL.createObjectURL(audio)
    //   this.product.audios[i] = blob
    //   this.$refs[`audioNode${i}`][0].load()
    //   this.$forceUpdate()
    // },
    async uploadImage(i, type) {
      let image = event.target.files[0]
      if(!await this.$func.fileValidation(image)) {
        return
      }
      if(type == 'image') {
        this.images[i].data = image
        this.images[i].src = await this.$func.fileToBase64(image)
        this.images[i].new = true
      }
      else if(type == 'free_image') {
        this.free_images[i].data = image
        this.free_images[i].src = await this.$func.fileToBase64(image)
        this.free_images[i].new = true
      }
      this.$forceUpdate()
    },
    deleteProductUnit(unit) {
      unit.data = unit.src = ''
    },
    // deleteAudio(i) {
    //   this.audios[i] = null
    //   this.product.audios = []
    //   this.product.audios_id = []
    // },
    getSellers() {
      this.axios.post('/admin/sellers', {
        search: [],
        page: 1,
        size: 999999
      }).then(response => {
        this.sellers = response.data.data
      })
    },
    // submitAudio() {
    //   return new Promise((resolve, reject) => {
    //     if(this.product.audios_id.length > 0 || !this.audios[0]) {
    //       resolve()
    //     }
    //     else {
    //       let formData = new FormData()
    //       formData.append('file', this.audios[0])
    //       this.axios.post('/admin/product/audio', formData, {
    //         headers: {
    //           'Content-Type': 'multipart/form-data'
    //         }
    //       }).then(response => {
    //         this.product.audios_id = [response.data]
    //         resolve()
    //       })
    //     }
    //   })
    // },
    // submitVideo() {
    //   return new Promise((resolve, reject) => {
    //     if(this.product.videos_id.length > 0 || !this.videos[0]) {
    //       resolve()
    //     }
    //     else {
    //       let formData = new FormData()
    //       formData.append('file', this.videos[0])
    //       this.axios.post('/admin/product/video', formData, {
    //         headers: {
    //           'Content-Type': 'multipart/form-data'
    //         }
    //       }).then(response => {
    //         this.product.videos_id = [response.data]
    //         resolve()
    //       })
    //     }
    //   })
    // },
    edit(unit, type) {
      let formData = new FormData()
      let config = {
        url: `/admin/edit/${type}`,
        method: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
        onUploadProgress: e => {
          this.progress = e.loaded / e.total * 100
        }
      }
      formData.append('uuid', unit.uuid)
      formData.append(type, unit.data)
      return this.axios(config).finally(() => this.progress = 0)
    },
    async submit() {
      if(!this.formIsValid) {
        return
      }
      this.$root.$emit('loading', true)
      let formData = new FormData()
      // let oldPrice = this.product.price
      // this.product.price = this.$func.price2peach(this.product.price, this.product.product_type)
      Object.keys(this.product).forEach(key => formData.append(key, (typeof this.product[key] == 'boolean') ? +this.product[key] : this.product[key]))
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        method: 'POST',
        data: formData,
        onUploadProgress: e => {
          this.progress = e.loaded / e.total * 100
        }
      }
      if(this.updating) {
        config.url = `/admin/edit/product`
        formData.append('product_id', this.product.id)

        // Upload new image or video
        if(this.product.product_type == 'video' || this.product.product_type == 'story') {
          this.videos.filter(unit => unit.new && !unit.uuid).forEach(unit => {
            formData.append('video', unit.data)
          })
        }
        else if(this.product.product_type == 'photo' || this.product.product_type == 'clothes') {
          this.videos.filter(unit => unit.new && !unit.uuid && unit.data).forEach(unit => {
            formData.append(`${this.product.product_type == 'photo' ? 'video' : 'videos[]'}`, unit.data)
          })
          this.images.filter(unit => unit.new && !unit.uuid && unit.data).forEach(unit => {
            formData.append('images[]', unit.data)
          })
          this.free_images.filter(unit => unit.new && !unit.uuid && unit.data).forEach(unit => {
            // clothes products don't accept free_images[]
            formData.append(`${this.product.product_type == 'photo' ? 'free_images[]' : 'images[]'}`, unit.data)
          })
        }

        // Update existing image or video
        await Promise.all([
          this.videos.filter(unit => (unit.uuid && !unit.src) || (unit.new && unit.uuid)).map(async unit => {
            await this.edit(unit, 'video')
          }),
          this.images.filter(unit => (unit.uuid && !unit.src) || (unit.new && unit.uuid)).map(async unit => {
            await this.edit(unit, 'image')
          }),
          this.free_images.filter(unit => (unit.uuid && !unit.src) || (unit.new && unit.uuid)).map(async unit => {
            await this.edit(unit, 'image')
          })
        ])

        // Update product data
        this.axios(config).then(response => {
          this.$root.$emit('alert', 'success', '更新成功')
          this.$router.push('/admin/product')
        }).catch(e => {
          this.$root.$emit('alert', 'error',  e.response.data.message)
          // this.product.price = oldPrice
        }).finally(() => {
          this.progress = 0
          this.$root.$emit('loading', false)
        })
      }
      else {
        if(this.product.product_type != 'story' || (['story', 'chat'].includes(this.product.product_type) && this.product.story_type == 'image')) {
          this.images.filter(image => image.data).forEach(image => {
            formData.append(['story', 'chat'].includes(this.product.product_type) ? 'image' : 'images[]', image.data)
          })
        }
        this.free_images.filter(image => image.data).forEach(image => {
          // clothes products don't accept free_images[]
          formData.append(['photo'].includes(this.product.product_type) ? 'free_images[]' : 'images[]', image.data)
        })
        if(this.product.product_type != 'story' || (['story', 'chat'].includes(this.product.product_type)  && this.product.story_type == 'video')) {
          this.videos.filter(video => video.data).forEach(video => {
            formData.append(['clothes'].includes(this.product.product_type) ? 'videos[]' : 'video', video.data)
          })
        }
        if(!formData.has('videos[]')) {
          formData.append('videos[]', [])
        }
        config.url = `/admin/product`
        this.axios(config).then(response => {
          this.$root.$emit('alert', 'success', '新增成功')
          this.$router.push('/admin/product')
        }).catch(e => {
          this.$root.$emit('alert', 'error', e.response.data.message)
          // this.product.price = oldPrice
        }).finally(() => {
          this.progress = 0
          this.$root.$emit('loading', false)
        })
      }
    },
    async getProductData() {
      let response = await this.axios.get(`/admin/product/${this.$route.params.id}`)
      this.product = response.data
      // this.product.price = this.$func.peach2price(this.product.price, this.product.product_type)
      this.videos = await Promise.all(this.product.video_info.map(video => {
        let unit = this.$func.deepCopy(this.unit)
        unit.src = this.$HOST_URL + video.uuid_path
        unit.uuid = video.uuid
        unit.new = false
        return unit
      }))
      this.images = await Promise.all(this.product.image_info.filter(image => image.charged).map(image => {
        let unit = this.$func.deepCopy(this.unit)
        unit.src = this.$HOST_URL + image.uuid_path
        unit.uuid = image.uuid
        unit.new = false
        return unit
      }))
      this.free_images = await Promise.all(this.product.image_info
          .filter(image => !image.charged)
          .map(image => {
            let unit = this.$func.deepCopy(this.unit)
            unit.src = this.$HOST_URL + image.uuid_path
            unit.uuid = image.uuid
            unit.new = false
            return unit
          }))
      this.padProductUnit()
    },
  }
}
</script>

<style lang="scss">
.newProduct {
  .v-card__title {
    max-width: 950px;
  }
  .row {
    align-items: center;
    & > div:first-child {
      flex-grow: 0;
      min-width: 180px;
    }
    & > div:nth-child(2) {
      max-width: 800px;
    }
  }
  .v-subheader {
    white-space: nowrap;
  }
  i {
    color: unset !important;
  }
  .video-player {
    width: 100%;
  }
}
</style>